import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from 'src/app/modules/shared.module';
import { WorkoutViewerModule } from 'src/app/modules/workout-viewer/workout-viewer.module';
import { OnboardingWorkoutBuilderPage } from './onboarding-workout-builder.page';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedModule,
    WorkoutViewerModule,
  ],
  declarations: [OnboardingWorkoutBuilderPage],
  exports: [OnboardingWorkoutBuilderPage],
})
export class OnboardingWorkoutBuilderPageModule {}
